import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      background: 'white',
    },
    container: {
      display: 'flex',
      columnGap: theme.spacing(2),
      alignItems: 'center',
    },
    score: {
      fontWeight: theme.typography.fontWeightSemiBold + '!important',
    },
    title: {
      maxWidth: 420,
    },
    button: {
      verticalAlign: 'baseline',
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
    },
  }),
  { name: 'ScoringMethod' }
);
